import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=2ac3fd4d&shadow"
import script from "./Collections.vue?vue&type=script&lang=js&shadow"
export * from "./Collections.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Collections.vue?vue&type=style&index=0&id=2ac3fd4d&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports